import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import CompareApp from './components/CompareApp';
import { createApolloClient } from './graphql/client';
import './index.css';
import { debug, warn } from './utils/debug';

// Default selected products as a fallback - these will be overridden by auto-selection
const DEFAULT_SELECTED_PRODUCT_IDS: string[] = [];

const mountCompareApp = () => {
  const compareAppElement = document.querySelector<HTMLElement>('[data-mount-compare-app]');

  if (!compareAppElement) {
    warn('No element with data-mount-compare-app found');
    return;
  }

  // Log mounting for debugging
  debug("Mounting React Compare App");

  // Get configuration from data attributes or fallback to defaults
  const shopDomain = compareAppElement.dataset.shopDomain || 'www.getorchard.com';
  const storefrontToken = compareAppElement.dataset.storefrontToken || "5a36d10afcf50459af42a8665364914a";
  const apiVersion = compareAppElement.dataset.apiVersion || '2025-04';

  // Try to get initially selected products from data attribute
  let initialSelectedProductIds = DEFAULT_SELECTED_PRODUCT_IDS;
  if (compareAppElement.dataset.selectedProducts) {
    try {
      const parsedProducts = JSON.parse(compareAppElement.dataset.selectedProducts);
      if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
        initialSelectedProductIds = parsedProducts;
        debug("Using initially selected products from section settings:", initialSelectedProductIds);
      }
    } catch (e) {
      warn("Failed to parse initially selected products:", e);
    }
  }

  // Log for debugging
  debug("Shop Domain:", shopDomain);
  debug("API Version:", apiVersion);

  // Create Apollo client
  const client = createApolloClient(shopDomain, storefrontToken, apiVersion);
  const root = ReactDOM.createRoot(compareAppElement);

  root.render(
    <React.StrictMode>
      <ApolloProvider client={client}>
        <CompareApp
          initialSelectedProductIds={initialSelectedProductIds}
          maxProducts={3}
          collectionHandle="all-products-oos-for-zarak"
        />
      </ApolloProvider>
    </React.StrictMode>
  );
};

// Initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountCompareApp);
} else {
  mountCompareApp();
}
